import { request } from '../utils/request';

export const fetchProcessHistories = params =>
  request.get('/process-alert-service/process-histories', { params });

export const runCronJobApi = params =>
  request.get('/process-alert-service/cron-job', { params });
